{
    "name": "shanghai",
    "comment": "Next feature hardfork after the London HF",
    "url": "https://github.com/ethereum/pm/issues/356",
    "status": "Pre-Draft",
    "eips": []
}
